export const flushStorage = (storageKey) => {
    sessionStorage.removeItem(storageKey);
}

export const setStorage = (storageKey, value) => {
  return sessionStorage.setItem(storageKey, JSON.stringify(value));
}

export const getFromStorage = (storageKey) => {
  const item = sessionStorage.getItem(storageKey);

  return item ? JSON.parse(item) : null;
}

export const setLocalStorage = (storageKey, value) => {
  return localStorage.setItem(storageKey, JSON.stringify(value));
}

export const getLocalStorage = (storageKey) => {
  const item = localStorage.getItem(storageKey);
  return item ? JSON.parse(item) : null;
}